var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.1C6 0.768629 6.26863 0.5 6.6 0.5L9.4 0.5C9.73137 0.5 10 0.768629 10 1.1C10 1.43137 9.73137 1.7 9.4 1.7H6.6C6.26863 1.7 6 1.43137 6 1.1Z",
    fill: "#272932"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.1C6 4.76863 6.26863 4.5 6.6 4.5H9.4C9.73137 4.5 10 4.76863 10 5.1C10 5.43137 9.73137 5.7 9.4 5.7H6.6C6.26863 5.7 6 5.43137 6 5.1Z",
    fill: "#272932"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.1C0 8.76863 0.268629 8.5 0.6 8.5L9.4 8.5C9.73137 8.5 10 8.76863 10 9.1C10 9.43137 9.73137 9.7 9.4 9.7H0.600001C0.26863 9.7 0 9.43137 0 9.1Z",
    fill: "#272932"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.1C0 12.7686 0.268629 12.5 0.6 12.5L5.4 12.5C5.73137 12.5 6 12.7686 6 13.1C6 13.4314 5.73137 13.7 5.4 13.7H0.600001C0.26863 13.7 0 13.4314 0 13.1Z",
    fill: "#272932"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68056 5.5H0V0.5H1.69444C2.1713 0.5 2.58179 0.600097 2.92593 0.800293C3.27006 0.99886 3.53472 1.2845 3.71991 1.65723C3.90664 2.02995 4 2.47591 4 2.99512C4 3.51595 3.90664 3.96354 3.71991 4.33789C3.53472 4.71224 3.26852 4.99951 2.9213 5.19971C2.57562 5.3999 2.16204 5.5 1.68056 5.5ZM1.00231 4.59424H1.63889C1.93519 4.59424 2.18441 4.5389 2.38657 4.42822C2.59028 4.31592 2.74306 4.14258 2.84491 3.9082C2.9483 3.6722 3 3.36784 3 2.99512C3 2.62565 2.9483 2.32373 2.84491 2.08936C2.74306 1.85498 2.59105 1.68245 2.38889 1.57178C2.18673 1.4611 1.9375 1.40576 1.6412 1.40576H1.00231V4.59424Z",
    fill: "#272932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.aff57f732a20d4a9a1946e31a02b156d.svg";
export { ForwardRef as ReactComponent };